<template>
  <div>
    <div>
      <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
        <li
          :class="fxsymbolprice == 0 ? 'active' : ''"
          v-on:click.prevent="fxsymbolprice = 0"
        >
          <a href="#">{{ $t("dash_overview") }}</a>
        </li>
        <li
          :class="fxsymbolprice == 1 ? 'active' : ''"
          v-on:click.prevent="fxsymbolprice = 1"
        >
          <a href="#">{{ $t("dash_traderRoom") }}</a>
        </li>
      </ul>
    </div>
    <div v-show="fxsymbolprice == 0">
      <div
        class="progressSectionArea"
        v-if="parseInt(get_user.verified_status) != 2"
      >
        <div
          class="progressSection whiteBG d-flex align-items-center justify-content-between mb- p-2 border-0 mb-4"
          role="alert"
          v-if="parseInt(get_user.verified_status) != 2"
        >
          <!-- <div class="btContent">
                        <p><strong>Set up your fxview account</strong></p>
                    </div> -->
          <div
            class="processingBar d-flex align-items-center mb-0 border-0 p-0"
          >
            <div class="set-size charts-container mr-3">
              <div class="pie-wrapper progress-45 style-2">
                <vue-circle
                  :progress="userCstep == 0 ? 0 : userCstep * 20"
                  :size="60"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="4.7"
                  insert-mode="append"
                  :thickness="3"
                  :show-percent="true"
                  ref="completeCircle"
                >
                </vue-circle>
              </div>
            </div>
            <div class="pieText">
              <p>{{ $t("welcm_fewStepAway") }}</p>
              <h3>{{ $t("welcm_activateFxviewAccountNow") }}</h3>
            </div>
          </div>
          <div class="barSusscess position-relative">
            <div class="progress mb-3">
              <div class="progress-bar" :style="getProgressPercentage()"></div>
            </div>
            <div
              class="d-flex align-items-center w-100 barDotArea justify-content-between"
            >
              <div
                class="checkCircle"
                :class="{ uncheck: parseInt(get_user.step) < 1 }"
              >
                <feather
                  size="12px"
                  type="check"
                  v-if="parseInt(get_user.step) >= 1"
                ></feather>
              </div>
              <div
                class="checkCircle"
                :class="{ uncheck: parseInt(get_user.step) < 2 }"
              >
                <feather
                  size="12px"
                  type="check"
                  v-if="parseInt(get_user.step) >= 2"
                ></feather>
              </div>
              <div
                class="checkCircle"
                :class="{ uncheck: parseInt(get_user.step) < 3 }"
              >
                <feather
                  size="12px"
                  type="check"
                  v-if="parseInt(get_user.step) >= 3"
                ></feather>
              </div>
              <!-- {{get_user.verified_status}} -->
              <div
                class="checkCircle"
                :class="{ uncheck: parseInt(get_user.step) < 4 }"
              >
                <feather
                  size="12px"
                  type="check"
                  v-if="parseInt(get_user.step) >= 4"
                ></feather>
              </div>
              <div
                class="checkCircle"
                :class="{ uncheck: parseInt(get_user.verified_status) != 2 }"
              >
                <feather
                  size="12px"
                  type="check"
                  v-if="parseInt(get_user.verified_status) == 2"
                ></feather>
              </div>
            </div>
            <!-- <div class="d-flex align-items-center w-100">
                            <div class="checkCircle" :class="{'uncheck':(parseInt(get_user.step) < 1)}">
                                <feather size="12px" type="check" v-if="parseInt(get_user.step) >= 1"></feather>
                            </div>
                            <div class="progress">
                                <div class="progress-bar" :style="(parseInt(get_user.step) < 2)?'width:100%':'width:0%'"></div>
                            </div>
                            <div class="checkCircle" :class="{'uncheck':(parseInt(get_user.step) < 2)}">
                                <feather size="12px" type="check" v-if="parseInt(get_user.step) >= 2"></feather>
                            </div>
                            <div class="progress">
                                <div class="progress-bar" style="width:100%"></div>
                            </div>
                            <div class="checkCircle" :class="{'uncheck':(parseInt(get_user.step) < 2)}">
                                <feather size="12px" type="check" v-if="parseInt(get_user.step) >= 2"></feather>
                            </div>
                        </div>
 -->
            <div
              class="d-flex align-items-center justify-content-between inforMation mt-1"
            >
              <p class="mb-0">{{ $t("dash_personalInfo") }}</p>
              <p class="mb-0 text-right">Financial Details</p>
              <p class="mb-0 text-right">Questionnaire</p>
              <p class="mb-0 text-center">{{ $t("dash_declaration") }}</p>
              <p class="mb-0 text-right">Document uploaded</p>
              <!-- <p class="mb-0 text-right">Trading Enabled & WD upto $500</p>
              <p class="mb-0 text-right">Unlimited Withdrawal</p> -->
            </div>
          </div>
          <!-- <div class="statComplete  mb-0">
                        <h3 class="align-items-center d-flex">{{(parseInt(get_user.step)*33)||'0'}}<sub>%</sub><span class="green">Done</span></h3>                        
                    </div> -->
          <div class="stepComlpe mb-0" v-if="parseInt(get_user.step) >= 5">
            <a
              href=""
              @click.prevent="redirect()"
              class="prism_btn redBG btn_sm lift"
              >See Status</a
            >
          </div>
          <div class="stepComlpe mb-0" v-else>
            <router-link
              :to="stepPageOpenFunc(get_user.step)"
              class="prism_btn redBG btn_sm lift"
              >{{ $t("dash_completeReg") }}</router-link
            >
          </div>
        </div>
        <div
          class="progressSection whiteBG mb-3 d-flex align-items-center justify-content-between"
          v-else-if="parseInt(get_user.step) == 3"
        >
          <div
            class="btContent d-flex align-items-center justify-content-between"
          >
            <img
              src="../../../../static/fxView/images/steps.svg"
              alt="Complete Registration"
              class="mr-5"
              width="80"
            />
            <div class="mr-5">
              <h4>{{ $t("prof_undrreview") }}</h4>
              <p>{{ $t("dash_checkticketstatus") }}</p>
            </div>
            <a href="" @click.prevent="redirect()" class="common_btn btn_sm">{{
              $t("dash_clickhere")
            }}</a>
          </div>
        </div>
        <div
          class="progressSection whiteBG mb-3 d-flex align-items-center justify-content-between"
          v-else-if="parseInt(get_user.step) == 5"
        >
          <div
            class="processingBar d-flex align-items-center mb-0 border-0 p-0"
          >
            <div class="set-size charts-container mr-3">
              <div class="pie-wrapper progress-45 style-2">
                <vue-circle
                  :progress="userCstep == 0 ? 0 : userCstep * 20"
                  :size="60"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="4.7"
                  insert-mode="append"
                  :thickness="3"
                  :show-percent="true"
                  ref="completeCircle"
                >
                </vue-circle>
              </div>
            </div>
            <div class="pieText">
              <p>{{ $t("welcm_fewStepAway") }}</p>
              <h3>{{ $t("welcm_activateFxviewAccountNow") }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-5 tradingArea flex-row-reverse">
        <div class="col-12 col-md-6 mobResponsive">
          <div class="d-flex position-relative mb-2 autoScroll-mob">
            <ul class="homemarketsummeryTab d-flex align-items-center">
              <li
                :class="fxsymbolpriceMu == 0 ? 'active' : ''"
                v-on:click.prevent="fxsymbolpriceMu = 0"
              >
                <a href="#">{{ $t("dash_marketSummary") }}</a>
              </li>
              <li
                :class="fxsymbolpriceMu == 1 ? 'active' : ''"
                v-on:click.prevent="fxsymbolpriceMu = 1"
              >
                <a href="#">{{ $t("dash_marketInsight") }}</a>
              </li>
              <li
                :class="fxsymbolpriceMu == 2 ? 'active' : ''"
                v-on:click.prevent="fxsymbolpriceMu = 2"
              >
                <a href="#">{{ $t("dash_news") }}</a>
              </li>
              <li
                :class="fxsymbolpriceMu == 3 ? 'active' : ''"
                v-on:click.prevent="fxsymbolpriceMu = 3"
              >
                <a href="#">{{ $t("dash_EconomicCal") }}</a>
              </li>
            </ul>
          </div>
          <div class="whiteBG radius dashboardCustomHeight p-3">
            <div class="showManulTabs">
              <div class="marketSummary" v-show="fxsymbolpriceMu == 0">
                <div class="chatModule-el">
                  <!-- <div class="active CahrtShow-module">
                                        <keep-alive>
                                            <app-small-chart :loadChart="loadChart2" :loadChart33 ="loadChart3" ref="chart"  type="small"/>
                                        </keep-alive>
                                    </div> -->
                  <div class="scrollbar pricefeedscroll">
                    <price-index-section></price-index-section>
                  </div>
                </div>
              </div>
              <div
                class="AutoChartist scrollbar dashboardData homeautochartist tradingIdeas"
                v-if="fxsymbolpriceMu == 1"
              >
                <div
                  v-if="hoopsData.totalRecords && hoopsData.totalRecords > 0"
                >
                  <div
                    class="card mb-3 pb-3"
                    v-for="(list, index) in hoopsData.records"
                    v-if="index < 5"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="thumbnail" v-if="list.image_url">
                        <img :src="list.image_url" class="card-img-top" />
                      </div>
                      <div class="card-body">
                        <h4 class="card-title">
                          <router-link
                            to="/research-and-education/Market-Insights"
                            class="green"
                            v-html="list.text.substring(0, 160)"
                          ></router-link>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="noRecordFound" v-else-if="!pageLoader">
                  <img
                    src="../../../../static/fxView/images/search.svg"
                    alt="no record found"
                  />
                  <p>{{ $t("dash_thereIsNoRecord") }}</p>
                </div>
              </div>
              <div
                class="newsIdeas scrollbar dashboardData"
                v-if="fxsymbolpriceMu == 2"
              >
                <div class="news mb-3" v-if="currentNews.totalRecords">
                  <div
                    class="homeNews tradingIdeas"
                    v-if="
                      currentNews.totalRecords && currentNews.totalRecords > 0
                    "
                  >
                    <div
                      class="card mb-3 pb-3"
                      v-for="(list, index) in currentNews.records"
                      v-if="currentNews.totalRecords > 0 && index < 10"
                    >
                      <div class="d-flex justify-content-between">
                        <div class="thumbnail">
                          <img
                            :src="list.image"
                            class="card-img-top"
                            v-if="list.image"
                          />
                          <img
                            :src="getImage(list.tags, list.title, list._id)"
                            class="card-img-top"
                            v-else
                          />
                        </div>
                        <div class="card-body">
                          <h4 class="card-title">
                            <a href="#" @click.prevent="singleNews = list">{{
                              list.title
                            }}</a>
                          </h4>
                          <span v-if="list.source != 'FXS'">
                            <p class="card-text mb-0" :ref="'less' + index">
                              <span
                                v-html="
                                  list.description.substring(0, 150) + '..'
                                "
                              ></span
                              ><!--  <span class="showmore green" @click="detailDiv(index,'more')" v-if="list.description && list.description.length > 150">Show More</span> -->
                            </p>
                            <!-- <p class="card-text mb-0 hide" :ref="'more'+index"><span v-html="list.description"></span> <span class="showmore green" @click="detailDiv(index,'less')">Show Less</span></p> -->
                          </span>
                          <!-- <span v-else-if="newsDetail[list._id]">
                                                        <p class="card-text mb-0" :ref="'less'+index">
                                                            <span v-html="newsDetail[list._id].description.concat(newsDetail[list._id].summary).substring(0,150)"></span> 
                                                            <span class="showmore green" @click="detailDiv(index,'more')" v-if="newsDetail[list._id].description && newsDetail[list._id].summary && newsDetail[list._id].description.concat(newsDetail[list._id].summary).length > 150">Show More</span>
                                                        </p>
                                                        <p class="card-text mb-0 hide" :ref="'more'+index">
                                                            <span v-html="newsDetail[list._id].description.concat(newsDetail[list._id].summary)"></span>
                                                            <span class="showmore green" @click="detailDiv(index,'less')">Show Less</span>
                                                        </p>
                                                    </span> -->
                          <span v-else>
                            <p class="card-text mb-0" :ref="'less' + index">
                              <span
                                v-html="
                                  list.description
                                    .concat(list.summary)
                                    .substring(0, 150) + '..'
                                "
                              ></span>
                              <!-- <span class="showmore green" @click="detailDiv(index,'more')" v-if="list.description && list.summary && list.description.concat(list.summary).length > 150">Show More</span> -->
                            </p>
                            <!-- <p class="card-text mb-0 hide" :ref="'more'+index">
                                                            <span v-html="list.description.concat(list.summary)"></span>
                                                            <span class="showmore green" @click="detailDiv(index,'less')">Show Less</span>
                                                        </p> -->
                          </span>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div class="date d-flex align-items-center">
                              {{ list.published | moment("DD MMMM YYYY") }}
                            </div>
                            <div class="newsSrc" v-if="list.source">
                              <p class="sm mb-0">
                                {{
                                  list.source == "FXS"
                                    ? "Fx Street"
                                    : list.source == "TE"
                                    ? "Trading Economics"
                                    : list.source
                                }}
                              </p>
                            </div>
                          </div>
                          <!-- <div class="date">
                                                        <span>{{list.published | moment("DD MMMM YYYY")}}</span>
                                                    </div> -->
                          <div
                            class="view-likes-block d-flex align-items-center justify-content-between"
                          >
                            <div class="colRight d-flex align-items-center">
                              <div class="date">
                                <small class="d-flex align-items-center">{{
                                  list.date | moment("DD MMMM YYYY")
                                }}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="noRecordFound" v-else-if="!pageLoader">
                  <img
                    src="../../../../static/fxView/images/search.svg"
                    alt="no record found"
                  />
                  <p>{{ $t("dash_thereIsNoRecord") }}</p>
                </div>
              </div>
              <div
                class="EconomicCalendar scrollbar dashboardData EcoResponsive"
                v-if="fxsymbolpriceMu == 3"
              >
                <div class="mb-3">
                  <div
                    class="homeNewsIdeas economicCalendar homeNews tradingIdeas"
                  >
                    <div class="tablePmm table-responsive">
                      <table class="table pmmTable">
                        <thead>
                          <tr>
                            <th>{{ $t("dash_Time") }}</th>
                            <th>{{ $t("dash_Country") }}</th>
                            <th>{{ $t("dash_event") }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="economicCalData != '' && index == 0"
                          v-for="(list, key, index) in economicCalData"
                        >
                          <tr>
                            <td colspan="3" class="p-0">
                              <table class="inntebbel cloud">
                                <tr class="fxs_c_period">
                                  <td
                                    colspan="3"
                                    class="text-center green stDate"
                                  >
                                    {{ key | moment("dddd, DD MMMM YYYY") }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr
                            v-for="(calenderDatewise, index1) in list"
                            :id="'calander' + index + '_' + index1"
                            @click.prevent="
                              getEvent(calenderDatewise.symbol, index, index1)
                            "
                          >
                            <td colspan="3" class="p-0">
                              <table class="inntebbel cloud">
                                <!--- -->
                                <tr class="clickAbleTR">
                                  <td class="nowrap">
                                    {{
                                      calenderDatewise.date | moment("hh:mm a")
                                    }}
                                  </td>
                                  <td class="d-flex align-items-center">
                                    <img
                                      :src="
                                        '../../../../static/fxView/images/country_images/' +
                                        ((calenderDatewise || {}).country || '').toLowerCase() +
                                        '.svg'
                                      "
                                      class="data_currency"
                                    />
                                    {{ calenderDatewise.country }}
                                  </td>
                                  <td
                                    v-html="
                                      calenderDatewise.event != '' &&
                                      calenderDatewise.event != null
                                        ? calenderDatewise.event
                                        : '-'
                                    "
                                  ></td>
                                </tr>
                                <tr
                                  class="showDiv"
                                  v-if="
                                    eventSymbol != '' &&
                                    calenderDatewise.symbol == eventSymbol &&
                                    eventIndex == index + '_' + index1
                                  "
                                >
                                  <td class="showContent" colspan="3">
                                    <span class="innerloader"
                                      ><complete-loading
                                        :pageloader_value="pageLoader"
                                        :type="'complete'"
                                        v-if="pageLoader"
                                      ></complete-loading
                                    ></span>
                                    <div
                                      class="displayContent d-flex text-left"
                                      :class="[
                                        {
                                          'full-child':
                                            !(
                                              eventData.lastnews &&
                                              eventData.lastnews.length
                                            ) ||
                                            !(
                                              eventData.chartdata &&
                                              eventData.chartdata.length > 0
                                            ),
                                        },
                                      ]"
                                    >
                                      <div
                                        class="lefArea child"
                                        v-if="
                                          eventData.lastnews &&
                                          eventData.lastnews.length
                                        "
                                      >
                                        <h3>
                                          {{
                                            eventData.lastnews[0].category ||
                                            "-"
                                          }}
                                        </h3>
                                        <p>
                                          {{
                                            eventData.lastnews[0].title || "-"
                                          }}
                                        </p>
                                        <div class="middleContent">
                                          <div
                                            class="d-flex align-items-center justify-content-between"
                                          >
                                            <h3>{{ $t("dash_frequency") }}</h3>
                                            <span class="dateFr">{{
                                              eventData.lastnews[0].date
                                                | moment("dd MMMM YYYY")
                                            }}</span>
                                          </div>
                                          <p>
                                            {{
                                              eventData.lastnews[0]
                                                .description || "-"
                                            }}
                                          </p>
                                        </div>
                                      </div>
                                      <div class="rightArea child">
                                        <bar-chart
                                          :chart_data="eventData.chartdata"
                                          v-if="
                                            eventData.chartdata &&
                                            eventData.chartdata.length > 0
                                          "
                                        />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                        <loader-component
                          :pageloader_value="pageLoader"
                          :type="'table'"
                          :colspan="'3'"
                          :list="Object.keys(economicCalData).length"
                          v-if="Object.keys(economicCalData).length == 0"
                        ></loader-component>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 pr-0">
          <div class="headValue d-flex align-items-center mb-2">
            <h3>{{ $t("dash_TradingAcc") }}</h3>
            <div class="rightValue ml-3 d-flex align-items-center">
              <div class="btn-group">
                <button
                  class="btn btn-secondary btn-sm dropdown-toggle liveDemobtn"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  @click.prevent="liveDemobtn = !liveDemobtn"
                >
                  {{ accountType == "1" ? "Live" : "Demo" }}
                </button>
                <ul class="dropdown-menu" :class="liveDemobtn ? 'show' : ''">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="accountType = '1'"
                      >{{ $t("dash_live") }}</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="accountType = '0'"
                      >{{ $t("dash_demo") }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="whiteBG radius dashboardCustomHeight">
            <div class="scrollbar dashboardData hometradingaccounts">
              <div class="inMiddle-area autoScroll-mob table-responsive">
                <table class="table customize tableAlign-left mob-width">
                  <thead>
                    <tr>
                      <td colspan="6" class="p-0 border-0">
                        <table class="inntebbel cloud">
                          <thead>
                            <tr class="incls-width">
                              <th>{{ $t("dash_Platform") }}</th>
                              <th>{{ $t("dash_tradAccId") }}</th>
                              <th>{{ $t("dash_Leverage") }}</th>
                              <th>{{ $t("dash_currency") }}</th>
                              <th v-if="accountType == '1'">&nbsp;</th>
                              <th>&nbsp;</th>
                            </tr>
                          </thead>
                        </table>
                      </td>
                    </tr>
                  </thead>
                  <account-list-table
                    v-if="
                      getaccList().totalRecords && getaccList().totalRecords > 0
                    "
                    :accountlist="getaccList().records"
                    :pageLoader="pageLoader"
                    :listType="accountType"
                  />
                  <loader-component
                    :pageloader_value="pageLoader"
                    :type="'table'"
                    :colspan="1"
                    :list="getaccList()"
                    v-else
                  ></loader-component>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="fxsymbolprice == 1"
      :class="advanceChart ? 'advanceFullChart' : ' '"
    >
      <!-- <div class="whiteBG p-3 mb-3">
        <div class="row no-gutters">
          <div class="col-12 col-md-12">
            <div>
              <app-advanced-chart
                :loadChart="loadChart"
                ref="chart"
                type="big"
              />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="titleCard">
              <h3>Market Watch</h3>
            </div>
            <price-feed-section></price-feed-section>
          </div>
          <div class="col-12 col-md-8">
            <div class="mainCahrt-area">
              <div
                class="titleCard d-flex align-items-center justify-content-between"
              >
                <h3>Chart</h3>
                <a
                  @click.prevent="advanceChart = !advanceChart"
                  href="#"
                  class="grd_btn"
                  >Advance Chart</a
                >
              </div>
              <span class="CahrtShow-module">
                <keep-alive>
                  <app-advanced-chart
                    :loadChart="loadChart"
                    ref="chart"
                    type="big"
                  />
                </keep-alive>
              </span>
            </div>
          </div>
        </div>
      </div> -->
      <div class="traderRoomNews m-0" :class="advanceChart ? 'd-none' : ' '">
        <div class="tradeIdea_element mb-4">
          <ul class="rightTabs-nifty d-flex align-items-center mb-3">
            <!-- <li
              :class="fxsymbolpriceTr == 0 ? 'active' : ''"
              v-on:click.prevent="fxsymbolpriceTr = 0"
            >
              <a href="#">{{ $t("dash_autochartist") }}</a>
            </li> -->
            <li
              :class="fxsymbolpriceTr == 1 ? 'active' : ''"
              v-on:click.prevent="fxsymbolpriceTr = 1"
            >
              <a href="#">{{ $t("dash_news") }}</a>
            </li>
            <li
              :class="fxsymbolpriceTr == 2 ? 'active' : ''"
              v-on:click.prevent="fxsymbolpriceTr = 2"
            >
              <a href="#">{{ $t("dash_EconomicCal") }}</a>
            </li>
          </ul>
          <div class="showManulTabs whiteBG radius p-3">
            <div class="AutoChartist tradingIdeas" v-if="fxsymbolpriceTr == 0">
              <div class="row">
                <div
                  class="col-4"
                  v-for="(list, index) in autoChartist.records"
                  v-if="autoChartist.totalRecords > 0 && index < 9"
                >
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">
                        <img
                          src="/static/fxView/images/Polygon-up.svg"
                          alt=""
                          v-if="list.side.toUpperCase() == 'BUY'"
                          class="triangle"
                        />
                        <img
                          src="/static/fxView/images/Polygon-down.svg"
                          alt=""
                          v-else
                          class="triangle"
                        />
                        {{ list.isin }}
                      </h5>

                      <img
                        v-if="
                          $env_var.imageLinkPortfolio +
                          list.external_id +
                          '&img=' +
                          list.media_file_title
                        "
                        :src="
                          $env_var.imageLinkPortfolio +
                          list.external_id +
                          '&img=' +
                          list.media_file_title
                        "
                        class="mb-3 card-img-top"
                        :title="list.idea_title"
                      />
                      <img
                        v-else
                        src="@/assets/trade_idea_default.png"
                        class="mb-3 card-img-top"
                        :title="list.idea_title"
                      />
                      <h5 class="mb-3">{{ list.idea_title }}</h5>
                      <p class="card-text mb-3">{{ list.short_description }}</p>
                      <div
                        class="view-likes-block d-flex align-items-center justify-content-between"
                      >
                        <div class="currency-info d-flex align-items-center">
                          <div class="currency mr-3">
                            <!-- {{list.isin}}, {{list.}} -->
                          </div>
                          <span class="short">
                            <span class="badge badge-pill badge-success">{{
                              list.holding_period
                            }}</span>
                          </span>
                        </div>
                        <div class="colRight d-flex align-items-center">
                          <!--<div class="views d-flex align-items-center"><feather type="eye" class="mr-2"></feather> {{list.views}}</div>-->
                          <div class="date d-flex align-items-center">
                            <feather type="calendar" class="mr-2"></feather>
                            {{ list.date_created | moment("DD MMMM YYYY") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="newsIdeas" v-if="fxsymbolpriceTr == 1">
              <div class="homeNews whiteBG radiusbold mb-3">
                <!-- <app-market-news></app-market-news> -->
                <div class="row" v-if="currentNews.totalRecords">
                  <div
                    class="col-6 col-lg-6 blogSection"
                    v-for="(list, index) in currentNews.records"
                    v-if="
                      currentNews.totalRecords && currentNews.totalRecords > 0
                    "
                    :id="'all' + index"
                  >
                    <!-- @click.prevent="callGetDetail(list)" -->
                    <div class="card newTrade p-0 border-0">
                      <div class="card-body py-3 px-0 border-0 border-bottom">
                        <div class="row no-gutters px-3">
                          <div class="col-md-4 pr-2">
                            <img :src="list.image" v-if="list.image" />
                            <img
                              :src="getImage(list.tags, list.title, list._id)"
                              v-else
                            />
                          </div>
                          <div class="col-md-8 pl-2">
                            <h4
                              class="mb-0 BlogTitle"
                              @click.prevent="singleNews = list"
                            >
                              <a class="green" href="#">{{ list.title }}</a>
                            </h4>

                            <span v-if="list.source != 'FXS'">
                              <p class="card-text mb-1" :ref="'less' + index">
                                <span
                                  v-html="list.description.substring(0, 150)"
                                ></span>
                              </p>
                            </span>
                            <span v-else>
                              <p class="card-text mb-1" :ref="'less' + index">
                                <span
                                  v-html="
                                    list.description != '' &&
                                    list.description != null
                                      ? list.description
                                          .concat(list.summary)
                                          .substring(0, 150)
                                      : '-'
                                  "
                                ></span>
                              </p>
                            </span>
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <div class="date d-flex align-items-center">
                                {{ dateFunction(list.created) }}
                              </div>
                              <div class="newsSrc" v-if="list.source">
                                <p class="sm mb-0">
                                  {{
                                    list.source == "FXS"
                                      ? "Fx Street"
                                      : list.source == "TE"
                                      ? "Trading Economics"
                                      : list.source
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane whiteBG p-3 h-100"
                  id="ca"
                  v-else-if="!pageLoader"
                >
                  <h3 class="text-center">{{ $t("dash_nodata") }}</h3>
                </div>
              </div>
            </div>
            <div class="EconomicCalendar" v-if="fxsymbolpriceTr == 2">
              <div class="whiteBG radiusbold mb-3">
                <div class="economicCalendar" v-if="economicCalData != ''">
                  <table class="table table-striped table-responsive">
                    <thead>
                      <tr>
                        <td colspan="11" class="p-0">
                          <table class="inntebbel cloud">
                            <thead>
                              <tr>
                                <th class="country_flag">
                                  {{ $t("dash_time") }}
                                </th>
                                <th class="country_flag">
                                  {{ $t("dash_Country") }}
                                </th>
                                <th class="event-name">
                                  {{ $t("dash_event") }}
                                </th>
                                <th class="ImpactArea">
                                  {{ $t("dash_impact") }}
                                </th>
                                <th class="ActualArea">
                                  {{ $t("dash_actual") }}
                                </th>
                                <th class="ForecastArea">
                                  {{ $t("dash_forecast")
                                  }}<!-- <feather type="alert-circle"/> -->
                                </th>
                                <th class="PreviousArea">
                                  {{ $t("dash_previous") }}
                                </th>
                                <th class="PreviousArea"></th>
                              </tr>
                            </thead>
                          </table>
                        </td>
                      </tr>
                    </thead>
                    <tbody
                      v-if="economicCalData != '' && index == 0"
                      v-for="(list, key, index) in economicCalData"
                    >
                      <tr>
                        <td colspan="8" class="p-0">
                          <table class="inntebbel cloud">
                            <tr class="fxs_c_period">
                              <td colspan="7" class="text-center green stDate">
                                {{ key | moment("dddd, DD MMMM YYYY") }}
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr
                        v-for="(calenderDatewise, index1) in list"
                        :id="'calander' + index + '_' + index1"
                        @click.prevent.stop="
                          getEvent(calenderDatewise.symbol, index, index1)
                        "
                      >
                        <td colspan="7" class="p-0">
                          <table class="inntebbel cloud">
                            <!--- -->
                            <tr class="clickAbleTR">
                              <td class="TimeArea">
                                {{ calenderDatewise.date | moment("hh:mm a") }}
                              </td>
                              <td class="d-flex align-items-center">
                                <img
                                  :src="
                                    '../../../../static/fxView/images/country_images/' +
                                    ((calenderDatewise || {}).country || '').toLowerCase() +
                                    '.svg'
                                  "
                                  class="data_currency"
                                />
                                {{ calenderDatewise.country }}
                              </td>
                              <td
                                class="event-name"
                                v-html="
                                  calenderDatewise.event != '' &&
                                  calenderDatewise.event != null
                                    ? calenderDatewise.event
                                    : '-'
                                "
                              ></td>
                              <td class="ImpactArea">
                                <span
                                  :class="
                                    priorityLabel[calenderDatewise.importance]
                                  "
                                >
                                  <feather type="bar-chart"></feather>
                                </span>
                              </td>
                              <td
                                class="ActualArea"
                                v-html="
                                  calenderDatewise.actual != '' &&
                                  calenderDatewise.actual != null
                                    ? calenderDatewise.actual
                                    : '-'
                                "
                              ></td>
                              <td
                                class="ForecastArea"
                                v-html="
                                  calenderDatewise.forecast != '' &&
                                  calenderDatewise.forecast != null
                                    ? calenderDatewise.forecast
                                    : '-'
                                "
                              ></td>
                              <td
                                class="PreviousArea"
                                v-html="
                                  calenderDatewise.previous != '' &&
                                  calenderDatewise.previous != null
                                    ? calenderDatewise.previous
                                    : '-'
                                "
                              ></td>
                              <td class="PreviousArea">
                                <feather
                                  type="bell"
                                  v-if="calenderDatewise.symbol"
                                />
                              </td>
                            </tr>
                            <tr
                              class="showDiv"
                              v-if="
                                eventSymbol != '' &&
                                calenderDatewise.symbol == eventSymbol &&
                                eventIndex == index + '_' + index1
                              "
                            >
                              <td class="showContent" colspan="8">
                                <span class="innerloader"
                                  ><complete-loading
                                    :pageloader_value="pageLoader"
                                    :type="'complete'"
                                    v-if="pageLoader"
                                  ></complete-loading
                                ></span>
                                <div
                                  class="displayContent d-flex text-left"
                                  :class="[
                                    {
                                      'full-child':
                                        !(
                                          eventData.lastnews &&
                                          eventData.lastnews.length
                                        ) ||
                                        !(
                                          eventData.chartdata &&
                                          eventData.chartdata.length > 0
                                        ),
                                    },
                                  ]"
                                >
                                  <div
                                    class="lefArea child"
                                    v-if="
                                      eventData.lastnews &&
                                      eventData.lastnews.length
                                    "
                                  >
                                    <h3>
                                      {{
                                        eventData.lastnews[0].category || "-"
                                      }}
                                    </h3>
                                    <p>
                                      {{ eventData.lastnews[0].title || "-" }}
                                    </p>
                                    <div class="middleContent">
                                      <div
                                        class="d-flex align-items-center justify-content-between"
                                      >
                                        <h3>{{ $t("dash_frequency") }}</h3>
                                        <span class="dateFr">{{
                                          eventData.lastnews[0].date
                                            | moment("dd MMMM YYYY")
                                        }}</span>
                                      </div>
                                      <p>
                                        {{
                                          eventData.lastnews[0].description ||
                                          "-"
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="rightArea child">
                                    <bar-chart
                                      :chart_data="eventData.chartdata"
                                      v-if="
                                        eventData.chartdata &&
                                        eventData.chartdata.length > 0
                                      "
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                    <loader-component
                      :pageloader_value="pageLoader"
                      :type="'table'"
                      :colspan="'7'"
                      :list="Object.keys(economicCalData).length"
                      v-if="economicCalData == {}"
                    ></loader-component>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-popup" v-if="Object.keys(singleNews).length > 0">
      <section class="ipbPopUp homeNewsSection">
        <div class="containerArea">
          <div class="row showNewPop mb-4">
            <div class="col-12">
              <!--====================FULL NEWS SECTION POP=============================-->
              <div class="fullNewsSection show d-none">
                <div class="customPp">
                  <button
                    @click.prevent="singleNews = {}"
                    type="button"
                    class="close d-flex align-items-center justify-content-center"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body-p whiteBG p-3">
                  <h4 class="my-1" v-html="singleNews.title"></h4>
                  <div class="date d-flex align-items-center ml-auto mb-2">
                    {{ dateFunction(singleNews.created) }}
                  </div>

                  <div class="imgT d-inline-block my-3">
                    <figure class="pr-3">
                      <img
                        :src="singleNews.fxImages.Url_Large"
                        v-if="singleNews.image"
                      />
                      <img
                        :src="
                          getImage(
                            singleNews.tags,
                            singleNews.title,
                            singleNews._id
                          )
                        "
                        v-else
                      />
                    </figure>
                    <p v-html="singleNews.description"></p>
                  </div>
                </div>
              </div>
              <!--====================End FULL NEWS SECTION POP=============================-->
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import account_list_table from "../shared/tradingAccounts/account-list-table";
import advancedChart from "../shared/advanced-chart";
import smallChart from "../shared/chart";
import priceFeedSection from "../tradingAccounts/price_feed";
import market_news from "../research/pages/market_news.vue";
import priceIndexSection from "../tradingAccounts/price_index";
import { fxViewMixins } from "@/plugins/fxView";
import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
import VueCircle from "vue2-circle-progress";
import barChart from "../shared/barChart";
import moment from "moment";
export default {
  name: "Dashboard",
  mixins: [fxViewMixins],
  data() {
    return {
      pageLoader: false,
      loaderFuncRun: "1",
      advanceChart: false,
      fxsymbolprice: "0",
      fxsymbolpriceMu: "0",
      fxsymbolpriceTr: "1",
      //==========================================
      accountType: "1",
      accountArray: {},
      countries: [],
      id: "",
      loadChart: "EURUSD",
      loadChart2: "EURUSD",
      loadChart3: "EURUSD",
      liveDemobtn: false,
      priorityLabel: { 1: "yellow", 2: "orange", 3: "red" },
      // fill : { gradient: ["red", "green", "blue"] },
      fill: { color: "#25c16f" },
      imgData: {
        Currenc: {
          AUDUSD: 8,
          EURUSD: 11,
          GBPUSD: 10,
          NZDUSD: 8,
          USDCAD: 9,
          USDCHF: 7,
          USDJPY: 8,
        },
        Commodit: {
          GAS: 10,
          GOLD: 10,
          Oil: 10,
          Silver: 6,
        },
        Stock: {
          Stock: 5,
        },
      },
      imgIdList: {},
      singleNews: {},

      eventData: {},
      eventSymbol: "",
      eventIndex: "",
    };
  },
  components: {
    priceFeedSection: priceFeedSection,
    priceIndexSection: priceIndexSection,
    accountListTable: account_list_table,
    appAdvancedChart: advancedChart,
    appSmallChart: smallChart,
    appMarketNews: market_news,
    VueCircle,
    barChart,
  },
  methods: {
    dateFunction(getDate) {
      let last_seen_date = moment(new Date(getDate)).fromNow();
      return last_seen_date;
    },
    getaccList() {
      if (this.accountType == "1") {
        return this.liveAccountList;
      } else {
        return this.demoAccountList;
      }
    },

    getProgressPercentage() {
      if (
        parseInt(this.get_user.step) == 2
      ) {
        return "width:25%";
      } else if (
        parseInt(this.get_user.step) == 3
      ) {
        return "width:50%";
      } else if( 
        parseInt(this.get_user.step) == 4
      ) {
        return "width:75%";
      } else if (
        parseInt(this.get_user.step) == 5 &&
        parseInt(this.get_user.verified_status) != 1
      ) {
        return "width:75%";
      } else if (
        parseInt(this.get_user.step) == 5 &&
        parseInt(this.get_user.verified_status) == 1
      ) {
        return "width:75%";
      } else if (
        parseInt(this.get_user.step) == 5 &&
        parseInt(this.get_user.verified_status) == 2
      ) {
        return "width:100%";
      } else {
        return "width:0%";
      }
    },

    getEvent(data, index, index1) {
      if (data != "") {
        if (this.eventIndex == index + "_" + index1) {
          this.eventSymbol = "";
          this.eventIndex = "";
          return;
        }
        this.eventData = {};
        this.eventSymbol = data;
        this.eventIndex = this.eventIndex = index + "_" + index1;
        let inputJson = {
          globalParams: {
            Symbol: data,
          },
          localParams: { parameter: this },
        };
        this._runGetCalenderEvent(inputJson);
      }
    },
    getImage(tags, titles, id) {
      if (this.imgIdList.hasOwnProperty(id)) {
        return (
          "../../../../static/fxView/images/news/" + this.imgIdList[id] + ".jpg"
        );
      }
      let tag = tags ? tags.toLowerCase() : "";
      let title = titles ? titles.toLowerCase() : "";
      var name = "";
      for (let img in this.imgData) {
        if (tag.includes(img.toLowerCase())) {
          for (let curr in this.imgData[img]) {
            if (tag.includes(curr.toLowerCase())) {
              let length = this.imgData[img][curr];
              let num = Math.floor(Math.random() * length) + 1;
              name = curr + "/" + curr + "-" + num;
              break;
            } else if (title.includes(curr.toLowerCase())) {
              let length = this.imgData[img][curr];
              let num = Math.floor(Math.random() * length) + 1;
              name = curr + "/" + curr + "-" + num;
              break;
            }
          }
          if (name == "") {
            var list = Object.keys(this.imgData[img]);
            let num1 = Math.floor(Math.random() * list.length);
            let txt = "";
            if (num1 < 1 || num1 > list.length - 1) {
              txt = list[list.length - 1];
            } else {
              txt = list[num1];
            }
            let num2 = Math.floor(Math.random() * this.imgData[img][txt]) + 1;
            name = txt + "/" + txt + "-" + num2;
            // console.log(num1,txt,name)
          }
        }
      }
      if (!this.imgIdList.hasOwnProperty(id)) {
        this.imgIdList[id] = name;
      }
      // console.log('../../../../static/fxview/images/news/'+name+'.jpg')
      return (
        "../../../../static/fxView/images/news/" + this.imgIdList[id] + ".jpg"
      );
    },
    detailDiv(index, getData) {
      if (getData == "more") {
        $(this.$refs["more" + index]).removeClass("hide");
        $(this.$refs["less" + index]).addClass("hide");
      } else {
        $(this.$refs["more" + index]).addClass("hide");
        $(this.$refs["less" + index]).removeClass("hide");
      }
    },
    accountSelectFunc() {
      if (this.accountType == "1") {
        this.accountArray = {
          records: this.liveAccountList.records,
          totalRecords: this.liveAccountList.totalRecords,
        };
      } else {
        this.accountArray = {
          records: this.demoAccountList.records,
          totalRecords: this.demoAccountList.totalRecords,
        };
      }
    },
    selectTradingAccountFunc(getData) {
      if (this.id == getData.id) {
        this.id = "";
      } else {
        this.id = getData.id;
        if (getData != "") {
          let accountJson = {
            globalParams: {
              id: getData.id,
            },
            localParams: { parameter: this, getData: [getData] },
          };
          this._runAddLastSelectTradingAccount(accountJson);
        }
      }
    },
    economicList() {
      let date = [Date.now(), new Date(Date.now() + 15 * 24 * 3600 * 1000)];
      let from = moment(date[0]).format("YYYY-MM-DD");
      let to = moment(date[1]).format("YYYY-MM-DD");
      let inputJson = {
        globalParams: {
          filter: {
            from: from.toString(),
            to: to.toString(),
            priority: this.priority,
            countries: this.countries,
          },
          sort: [],
          search: "",
          page: "1",
          perPage: 15,
          offset: new Date().getTimezoneOffset(),
        },
        localParams: { parameter: this, loaderFuncRun: this.loaderFuncRun },
      };
      this._runGetEconomicCalData(inputJson);
    },
    listing() {
      if (this.$store.getters[Const.GET_AUTO_CHARTIST] != "") {
        this.loaderFuncRun = "0";
      }
      if (this.$store.getters[Const.GET_ECONOMIC_CALENDER_DATA] != "") {
        this.loaderFuncRun = "0";
      }
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: "",
          page: 1,
          perPage: 15,
        },
        localParams: { parameter: this, loaderFuncRun: this.loaderFuncRun },
      };
      this._runGetAutochartistData(inputJson);
      this._runGetHoopsData(inputJson);
      this.economicList();

      let newsJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: "",
          page: 1,
          perPage: 15,
          indicator: "all",
        },
        localParams: { parameter: this, loaderFuncRun: this.loaderFuncRun },
      };
      this._runGetCurrentNews(newsJson);
    },
    /*tradingAccountListFunc(){
				this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this , 'demo_live' : '1'}})
			}*/
  },
  mounted() {
    let _that = this;
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".liveDemobtn").length) {
        _that.liveDemobtn = false;
      }
    });
  },

  computed: {
      userCstep: function () {
        let currentStep = this.get_user.step;
        if ("tempStep" in this.get_user && currentStep < this.get_user.tempStep) {
          currentStep = this.get_user.tempStep;
        }
        this.userStep = currentStep;
        if (parseInt(this.userStep) == 0) {
          if (this.$refs.completeCircle) {
            this.$refs.completeCircle.updateProgress(0);
          }
        } else {
          if (this.$refs.completeCircle) {
            this.$refs.completeCircle.updateProgress((this.userStep) * 20);
          }
        }
        return this.get_user.step;
      },
    },
  created() {
    this.listing();
    // this.tradingAccountListFunc()
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/users/dashboard.vue